(function () {
  'use strict';

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/\+/g, 'plus')
      .replace(/[^a-z0-9]+/g, '')
      .trim();
  }

  function variantKey(size, customization, color) {
    return [size, customization, color].map(normalize).join('|');
  }

  function customizationMatches(variantCustomization, selectedCustomization) {
    var variantValue = normalize(variantCustomization);
    var selectedValue = normalize(selectedCustomization);
    return variantValue === selectedValue || (!variantValue && selectedValue === 'none');
  }

  function colorMatches(variantColor, selectedColor) {
    var variantValue = normalize(variantColor);
    var selectedValue = normalize(selectedColor);
    return variantValue === selectedValue || (!variantValue && !selectedValue);
  }

  function parseJson(root, selector, fallback) {
    var el = root.querySelector(selector);
    if (!el) return fallback;

    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      console.warn('[World Cup] JSON parse failed:', selector, error);
      return fallback;
    }
  }

  function selectedValue(root, name) {
    var input = root.querySelector('input[name="' + name + '"]:checked');
    return input ? input.value : '';
  }

  function setOptionDisabled(root, input, disabled) {
    var label = root.querySelector('label[for="' + input.id + '"]');
    input.disabled = disabled;
    if (label) {
      label.classList.toggle('is-disabled', disabled);
      label.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    }
  }

  function setSelectedClasses(root, selector) {
    var inputs = root.querySelectorAll(selector);
    Array.prototype.forEach.call(inputs, function (input) {
      var label = root.querySelector('label[for="' + input.id + '"]');
      if (label) label.classList.toggle('is-selected', input.checked);
    });
  }

  function selectFirstAvailable(root, name) {
    var inputs = root.querySelectorAll('input[name="' + name + '"]');
    for (var i = 0; i < inputs.length; i += 1) {
      if (!inputs[i].disabled) {
        inputs[i].checked = true;
        return inputs[i].value;
      }
    }
    return '';
  }

  function checkByValue(root, name, value) {
    var inputs = root.querySelectorAll('input[name="' + name + '"]');
    for (var i = 0; i < inputs.length; i += 1) {
      if (normalize(inputs[i].value) === normalize(value)) {
        inputs[i].checked = true;
        return true;
      }
    }

    return false;
  }

  function money(cents) {
    return '$' + ((parseInt(cents, 10) || 0) / 100).toFixed(2);
  }

  function setupWorldCupProduct(root) {
    var config = parseJson(root, '[data-world-cup-config]', {});
    var variants = parseJson(root, '[data-world-cup-variant-map]', []);
    var map = {};
    var productTeam = config.productTeam || root.dataset.productTeam || config.productTitle || '';

    variants.forEach(function (variant) {
      var key = variantKey(variant.size, variant.customization, variant.color);
      if (!map[key] || (!map[key].available && variant.available)) {
        map[key] = variant;
      }
    });

    window.WORLD_CUP_VARIANTS = window.WORLD_CUP_VARIANTS || {};
    window.WORLD_CUP_VARIANTS[config.productId || root.dataset.productId] = map;

    var priceEl = root.querySelector('[data-world-cup-price]');
    var priceNoteEl = root.querySelector('[data-world-cup-price-note]');
    var statusEl = root.querySelector('[data-world-cup-status]');
    var addButton = root.querySelector('[data-world-cup-add]');
    var primaryImage = root.querySelector('[data-world-cup-primary-image]');
    var galleryCells = root.querySelectorAll('[data-world-cup-gallery-color]');
    var sizeQtyInputs = root.querySelectorAll('[data-world-cup-size-quantity]');
    var nameInput = root.querySelector('[data-world-cup-name-input]');
    var numberInput = root.querySelector('[data-world-cup-number-input]');
    var personalizationFields = root.querySelector('[data-world-cup-personalization-fields]');
    var nameField = root.querySelector('[data-world-cup-name-field]');
    var numberField = root.querySelector('[data-world-cup-number-field]');

    function findVariant(size, customization, color) {
      var fallback = null;

      for (var i = 0; i < variants.length; i += 1) {
        var variant = variants[i];
        if (
          normalize(variant.size) === normalize(size) &&
          customizationMatches(variant.customization, customization) &&
          colorMatches(variant.color, color)
        ) {
          if (variant.available) return variant;
          if (!fallback) fallback = variant;
        }
      }

      return fallback || map[variantKey(size, customization, color)] || null;
    }

    function findPurchasableVariant(size, customization, color) {
      // Require a real Shopify variant for the exact size + customization so the
      // price shown always matches what checkout charges. No fabricated surcharge.
      var variant = findVariant(size, customization, color);
      if (variant) {
        return { variant: variant };
      }
      return null;
    }

    function sanitizeQuantity(value) {
      return Math.min(99, Math.max(0, parseInt(value, 10) || 0));
    }

    function selectedSizeQuantities() {
      var selections = [];

      Array.prototype.forEach.call(sizeQtyInputs, function (input) {
        var quantity = sanitizeQuantity(input.value);
        input.value = quantity;

        if (quantity > 0) {
          selections.push({
            size: input.dataset.size || '',
            quantity: quantity
          });
        }
      });

      return selections;
    }

    function updateSizeCardStates() {
      Array.prototype.forEach.call(sizeQtyInputs, function (input) {
        var card = input.closest('[data-world-cup-size-card]');
        if (card) {
          card.classList.toggle('has-quantity', sanitizeQuantity(input.value) > 0);
        }
      });

      setSelectedClasses(root, 'input[name="world_cup_customization"]');
    }

    function updatePersonalizationFields() {
      var customizationInput = root.querySelector('input[name="world_cup_customization"]:checked');
      var requiresName = customizationInput && customizationInput.dataset.requiresName === 'true';
      var requiresNumber = customizationInput && customizationInput.dataset.requiresNumber === 'true';
      var showAny = requiresName || requiresNumber;

      if (personalizationFields) personalizationFields.hidden = !showAny;
      if (nameField) nameField.hidden = !requiresName;
      if (numberField) numberField.hidden = !requiresNumber;

      if (!requiresName && nameInput) nameInput.value = '';
      if (!requiresNumber && numberInput) numberInput.value = '';
    }

    function updateGallery(color) {
      if (!galleryCells.length) return;

      var normalizedColor = normalize(color);
      var hasMatch = false;
      var fallbackColor = galleryCells[0] ? normalize(galleryCells[0].dataset.worldCupGalleryColor) : '';

      Array.prototype.forEach.call(galleryCells, function (cell) {
        if (normalize(cell.dataset.worldCupGalleryColor) === normalizedColor) {
          hasMatch = true;
        }
      });

      Array.prototype.forEach.call(galleryCells, function (cell) {
        var cellColor = normalize(cell.dataset.worldCupGalleryColor);
        var matches = hasMatch ? cellColor === normalizedColor : cellColor === fallbackColor;
        cell.hidden = !matches;
      });
    }

    function updateDisplay() {
      updatePersonalizationFields();
      updateSizeCardStates();

      var customization = selectedValue(root, 'world_cup_customization');
      var color = selectedValue(root, 'world_cup_color');
      updateGallery(color);
      var sizeSelections = selectedSizeQuantities();
      var totalCents = 0;
      var totalQuantity = 0;
      var missingSize = '';

      sizeSelections.forEach(function (selection) {
        var match = findPurchasableVariant(selection.size, customization, color);
        if (!match && !missingSize) {
          missingSize = selection.size;
          return;
        }

        if (match) {
          // Price always comes from the real Shopify variant so the page matches checkout.
          totalCents += (parseInt(match.variant.price, 10) || 0) * selection.quantity;
          totalQuantity += selection.quantity;
        }
      });

      if (priceEl) {
        priceEl.textContent = totalQuantity > 0 && !missingSize
          ? money(totalCents)
          : money(0);
      }

      if (priceNoteEl) {
        if (totalQuantity > 0 && !missingSize) {
          priceNoteEl.textContent = totalQuantity + ' shirt' + (totalQuantity === 1 ? '' : 's') + (color ? ' / ' + color : '') + ' / ' + customization;
        } else {
          priceNoteEl.textContent = 'Select quantities and customization';
        }
      }

      var isAvailable = totalQuantity > 0 && !missingSize;
      if (addButton) {
        addButton.disabled = !isAvailable;
        addButton.textContent = isAvailable
          ? 'Add to Cart - ' + money(totalCents)
          : 'Unavailable';
      }

      if (statusEl) {
        if (missingSize) {
          statusEl.textContent = missingSize + ' / ' + customization + (color ? ' / ' + color : '') + ' does not exist in Shopify variants yet.';
        } else {
          statusEl.textContent = totalQuantity > 0 ? '' : 'Choose at least one size quantity.';
        }
      }
    }

    function validateSelection() {
      var customization = selectedValue(root, 'world_cup_customization');
      var color = selectedValue(root, 'world_cup_color');
      var customizationInput = root.querySelector('input[name="world_cup_customization"]:checked');
      var requiresName = customizationInput && customizationInput.dataset.requiresName === 'true';
      var requiresNumber = customizationInput && customizationInput.dataset.requiresNumber === 'true';
      var nameValue = nameInput ? nameInput.value.trim().toUpperCase() : '';
      var numberValue = numberInput ? numberInput.value.trim() : '';
      var sizeSelections = selectedSizeQuantities();
      var items = [];

      if (!sizeSelections.length) {
        throw new Error('Please choose at least one size quantity.');
      }

      sizeSelections.forEach(function (selection) {
        var match = findPurchasableVariant(selection.size, customization, color);
        if (!match) {
          throw new Error(selection.size + ' / ' + customization + (color ? ' / ' + color : '') + ' does not exist in Shopify variants yet.');
        }

        items.push({
          size: selection.size,
          quantity: selection.quantity,
          variant: match.variant
        });
      });

      if (!items.length) {
        throw new Error('Please choose at least one size quantity.');
      }

      if (requiresName && !nameValue) {
        throw new Error('Please enter the name for the back print.');
      }

      if (requiresNumber && !numberValue) {
        throw new Error('Please enter the number for the back print.');
      }

      if (requiresName && nameValue.length > 6) {
        throw new Error('Name must be 6 characters or fewer.');
      }

      if (requiresNumber && numberValue.length > 2) {
        throw new Error('Number must be 2 digits or fewer.');
      }

      return {
        team: productTeam,
        customization: customization,
        color: color,
        nameValue: requiresName ? nameValue : '',
        numberValue: requiresNumber ? numberValue : '',
        items: items
      };
    }

    async function addToCart() {
      var selection;

      try {
        selection = validateSelection();
      } catch (error) {
        alert(error.message);
        return;
      }

      var cartItems = selection.items.map(function (item) {
        var properties = {
          'World Cup Team': selection.team,
          'World Cup Size': item.size,
          'Customization': selection.customization,
          '_world_cup_order': 'Yes',
          '_custom_order': 'Yes',
          '_world_cup_variant_key': variantKey(item.size, selection.customization, selection.color),
          '_world_cup_campaign': config.campaign || root.dataset.campaign || 'World Cup Collection'
        };

        if (selection.color) {
          properties['World Cup Color'] = selection.color;
        }

        if (selection.nameValue) {
          properties['Custom Name'] = selection.nameValue;
        }

        if (selection.numberValue) {
          properties['Custom Number'] = selection.numberValue;
        }

        return {
          id: parseInt(item.variant.id, 10),
          quantity: item.quantity,
          properties: properties
        };
      });

      if (addButton) {
        addButton.disabled = true;
        addButton.dataset.originalText = addButton.textContent;
        addButton.textContent = 'Adding to cart...';
      }

      if (statusEl) statusEl.textContent = '';

      try {
        var response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: cartItems
          })
        });

        if (!response.ok) {
          var errorText = await response.text();
          throw new Error(errorText || 'Unable to add this item to cart.');
        }

        if (statusEl) statusEl.textContent = 'Added to cart. Opening cart...';
        window.location.href = '/cart';
      } catch (error) {
        if (statusEl) statusEl.textContent = 'Could not add to cart. Please try again.';
        alert(error.message || 'Unable to add this item to cart.');
        if (addButton) {
          addButton.disabled = false;
          addButton.textContent = addButton.dataset.originalText || 'Add to Cart';
        }
      }
    }

    root.addEventListener('change', function (event) {
      if (event.target.name === 'world_cup_customization' || event.target.name === 'world_cup_color') {
        updateDisplay();
      }
    });

    if (nameInput) {
      nameInput.addEventListener('input', function () {
        nameInput.value = nameInput.value.toUpperCase().slice(0, 6);
      });
    }

    if (numberInput) {
      numberInput.addEventListener('input', function () {
        numberInput.value = numberInput.value.replace(/[^0-9]/g, '').slice(0, 2);
      });
    }

    Array.prototype.forEach.call(sizeQtyInputs, function (input) {
      input.addEventListener('input', updateDisplay);
    });

    root.addEventListener('click', function (event) {
      var minus = event.target.closest('[data-world-cup-size-minus]');
      var plus = event.target.closest('[data-world-cup-size-plus]');
      if (!minus && !plus) return;

      var card = event.target.closest('[data-world-cup-size-card]');
      var input = card ? card.querySelector('[data-world-cup-size-quantity]') : null;
      if (!input) return;

      var quantity = sanitizeQuantity(input.value);
      input.value = plus ? Math.min(99, quantity + 1) : Math.max(0, quantity - 1);
      updateDisplay();
    });

    if (addButton) addButton.addEventListener('click', addToCart);

    var thumbnails = root.querySelectorAll('[data-wc-thumbnail]');
    Array.prototype.forEach.call(thumbnails, function (thumb) {
      thumb.addEventListener('click', function () {
        if (primaryImage) {
          primaryImage.src = thumb.dataset.imageSrc || primaryImage.src;
          primaryImage.alt = thumb.dataset.imageAlt || primaryImage.alt;
        }
        Array.prototype.forEach.call(thumbnails, function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      });
    });

    updateDisplay();
  }

  function setupWorldCupCollectionFilter() {
    var filterNav = document.querySelector('[data-wc-filter]');
    if (!filterNav) return;

    var buttons = filterNav.querySelectorAll('[data-wc-filter-btn]');
    var cards = document.querySelectorAll('[data-wc-card]');

    function normalizeTeam(value) {
      return String(value || '').toLowerCase().trim();
    }

    function applyFilter(activeTeam) {
      var isAll = activeTeam === 'all';

      Array.prototype.forEach.call(cards, function (card) {
        var cardTeam = normalizeTeam(card.dataset.team);
        var matches = isAll || cardTeam === normalizeTeam(activeTeam);
        card.classList.toggle('is-hidden', !matches);
      });

      Array.prototype.forEach.call(buttons, function (btn) {
        var active = btn.dataset.team === activeTeam;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    Array.prototype.forEach.call(buttons, function (btn) {
      btn.addEventListener('click', function () {
        applyFilter(btn.dataset.team);
      });
    });
  }

  function setupHeroMuteButton() {
    var btn = document.getElementById('wc-hero-mute-btn');
    var video = document.getElementById('wc-hero-video');
    if (!btn || !video) return;

    var iconOff = btn.querySelector('.wc-hero__mute-icon--off');
    var iconOn  = btn.querySelector('.wc-hero__mute-icon--on');
    var userMuted = false;

    function syncBtn(muted) {
      if (muted) {
        iconOff.removeAttribute('hidden');
        iconOn.setAttribute('hidden', '');
        btn.setAttribute('aria-label', 'Unmute video');
        btn.setAttribute('aria-pressed', 'true');
      } else {
        iconOff.setAttribute('hidden', '');
        iconOn.removeAttribute('hidden');
        btn.setAttribute('aria-label', 'Mute video');
        btn.setAttribute('aria-pressed', 'false');
      }
    }

    function playWithSound() {
      if (!userMuted) {
        video.muted = false;
        video.defaultMuted = false;
        video.volume = 1;
        syncBtn(false);
      }

      var promise = video.play();
      if (promise !== undefined) {
        promise.catch(function () {
          if (userMuted) return;

          video.muted = true;
          syncBtn(true);

          var mutedPromise = video.play();
          if (mutedPromise !== undefined) {
            mutedPromise.catch(function () {});
          }
        });
      }
    }

    btn.addEventListener('click', function () {
      userMuted = !video.muted;
      video.muted = userMuted;
      syncBtn(video.muted);

      if (video.paused) {
        var resumePromise = video.play();
        if (resumePromise !== undefined) {
          resumePromise.catch(function () {});
        }
      }
    });

    video.addEventListener('volumechange', function () {
      syncBtn(video.muted);
    });

    ['click', 'pointerdown', 'touchstart', 'keydown'].forEach(function (eventName) {
      document.addEventListener(eventName, playWithSound, { once: true, passive: true });
    });

    playWithSound();
  }

  function setupViewCollectionButton() {
    var btns = document.querySelectorAll('.wc-hero__view-btn, .wc-hero__shop-btn');
    Array.prototype.forEach.call(btns, function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        btn.blur();

        var target = document.getElementById('wc-collection-grid');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  function setupCardSparkles() {
    var imageWraps = document.querySelectorAll('.wc-card__image-wrap');
    if (!imageWraps.length) return;

    var PALETTE = [
      { r: 255, g: 116, b: 28 },
      { r: 255, g: 160, b: 80 },
      { r: 255, g: 200, b: 120 },
      { r: 255, g: 230, b: 180 },
      { r: 255, g: 255, b: 220 }
    ];
    var COUNT = 55;
    var FL = 280;
    var MAX_Z = 700;

    Array.prototype.forEach.call(imageWraps, function (wrap) {
      var canvas = document.createElement('canvas');
      canvas.setAttribute('aria-hidden', 'true');
      canvas.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;pointer-events:none;z-index:0;border-radius:inherit;';
      wrap.insertBefore(canvas, wrap.firstChild);

      var ctx = canvas.getContext('2d');
      var W = 1, H = 1;
      var running = false;
      var frameId = null;

      function resize() {
        W = canvas.width = wrap.offsetWidth || 200;
        H = canvas.height = wrap.offsetHeight || 200;
      }

      function Sparkle(initial) {
        this.reset(initial);
      }

      Sparkle.prototype.reset = function (initial) {
        this.x3 = (Math.random() - 0.5) * W * 2.2;
        this.y3 = (Math.random() - 0.5) * H * 2.2;
        this.z = initial ? Math.random() * MAX_Z : MAX_Z + 10;
        this.vz = Math.random() * 0.9 + 0.2;
        this.vx = (Math.random() - 0.5) * 0.2;
        this.vy = (Math.random() - 0.5) * 0.2;
        this.phase = Math.random() * Math.PI * 2;
        this.freq = Math.random() * 0.022 + 0.007;
        this.col = PALETTE[Math.floor(Math.random() * PALETTE.length)];
        this.baseSize = Math.random() * 1.0 + 0.3;
      };

      Sparkle.prototype.project = function () {
        var s = FL / (this.z + FL);
        return { sx: this.x3 * s + W * 0.5, sy: this.y3 * s + H * 0.5, s: s };
      };

      Sparkle.prototype.update = function () {
        this.z -= this.vz;
        this.x3 += this.vx;
        this.y3 += this.vy;
        if (this.z <= 0) this.reset(false);
      };

      Sparkle.prototype.draw = function (t) {
        var p = this.project();
        var sx = p.sx, sy = p.sy, s = p.s;
        if (sx < -40 || sx > W + 40 || sy < -40 || sy > H + 40) return;

        var twinkle = Math.sin(t * this.freq + this.phase) * 0.5 + 0.5;
        var size = this.baseSize * s * 3.2 * (0.5 + twinkle * 0.5);
        var alpha = Math.min(1, (0.2 + twinkle * 0.6) * s * 1.3);
        var r = this.col.r, g = this.col.g, b = this.col.b;

        ctx.save();
        ctx.globalAlpha = alpha;

        if (size > 0.7) {
          var glow = ctx.createRadialGradient(sx, sy, 0, sx, sy, size * 3.2);
          glow.addColorStop(0, 'rgba(' + r + ',' + g + ',' + b + ',0.4)');
          glow.addColorStop(1, 'rgba(' + r + ',' + g + ',' + b + ',0)');
          ctx.beginPath();
          ctx.arc(sx, sy, size * 3.2, 0, Math.PI * 2);
          ctx.fillStyle = glow;
          ctx.fill();
        }

        ctx.beginPath();
        ctx.arc(sx, sy, Math.max(0.3, size), 0, Math.PI * 2);
        ctx.fillStyle = 'rgb(' + r + ',' + g + ',' + b + ')';
        ctx.fill();
        ctx.restore();
      };

      var sparkles = [];
      var t = 0;

      function boot() {
        resize();
        sparkles = [];
        for (var i = 0; i < COUNT; i++) sparkles.push(new Sparkle(true));
      }

      function frame() {
        if (!running) return;
        ctx.clearRect(0, 0, W, H);
        t++;
        for (var i = 0; i < sparkles.length; i++) {
          sparkles[i].update();
          sparkles[i].draw(t);
        }
        frameId = requestAnimationFrame(frame);
      }

      var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          if (!sparkles.length) boot();
          running = true;
          frame();
        } else {
          running = false;
          if (frameId) cancelAnimationFrame(frameId);
        }
      }, { threshold: 0.1 });

      observer.observe(wrap);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var products = document.querySelectorAll('[data-world-cup-product]');
    Array.prototype.forEach.call(products, setupWorldCupProduct);

    setupWorldCupCollectionFilter();
    setupHeroMuteButton();
    setupViewCollectionButton();
    setupCardSparkles();
  });
})();
